import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import AppContent from '../_Shared/Layout/AppContent';

class RoleEdit extends React.Component {

    componentDidMount() {
        this.props.onActivate();
    }
    
    render() {
        const { role, loading, saveHandler } = this.props;
        return (<AppContent>
            <Grid container spacing={24}>
                {
                    loading &&
                    <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                }
                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <TextField autoFocus value={role.name} onChange={this.handleInputChange} id="name" name="name" label="Role Name" type="text" fullWidth />
                    </Grid>
                </Grid>
                <Grid container item spacing={24} >
                    <Grid item lg={3} xl={2}>
                        <TextField value={role.postClickLookback} onChange={this.handleInputChange} id="postClickLookback" name="postClickLookback" label="Post Click Lookback" type="number" />
                    </Grid>
                    <Grid item lg={3} xl={2}>
                        <TextField value={role.postViewLookback} onChange={this.handleInputChange} id="postViewLookback" name="postViewLookback" label="Post View Lookback" type="number" />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <TextField value={role.costModifier} onChange={this.handleInputChange} id="costModifier" name="costModifier" label="Cost Modifier" type="number" />
                    </Grid>
                </Grid>

                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <Button onClick={saveHandler} variant="contained" color="secondary">Save</Button>
                    </Grid>
                </Grid>
            </Grid>
        </AppContent >)
    }
}
export default RoleEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Roles/RoleEdit.js